export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_11.445d923a.jpg";